export default __webpack_public_path__ + "static/media/icon_bodybuilding.d5842179.svg";